(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsg-rezept-artikel"]) return;
  try {
    
  (() => {
    const fmt = (v, loc) => {
      if (v >= 20) return String(Math.round(v / 5) * 5);
      const whole = Math.floor(v), rest = v - whole;
      const fr = [[0.25, '¼'], [0.5, '½'], [0.75, '¾'], [1 / 3, '⅓'], [2 / 3, '⅔']].find(([x]) => Math.abs(rest - x) < 0.04);
      if (rest < 0.04) return String(whole);
      if (rest > 0.96) return String(whole + 1);
      if (fr) return (whole ? whole + ' ' : '') + fr[1];
      return (Math.round(v * 10) / 10).toLocaleString(loc === 'de' ? 'de-CH' : loc);
    };
    const clean = (s) => (s || '').replace(/\s+/g, ' ').trim();
    const slug = (s) => (s || '').toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'rezept';
    const ICONS = {
      whatsapp: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.6-.3z"/></svg>',
      mail: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M3.5 6l8.5 7 8.5-7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
      pdf: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 3h8l4 4v14H6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M14 3v4h4M12 10v7m-3-3l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      print: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M7 9V3h10v6M7 17H4v-7h16v7h-3M7 14h10v7H7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
    };
    let jsPdfPromise = null;
    const loadJsPdf = () => jsPdfPromise || (jsPdfPromise = new Promise((resolve, reject) => {
      if (window.jspdf) return resolve(window.jspdf);
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = () => resolve(window.jspdf); s.onerror = reject;
      document.head.append(s);
    }));
    const loadImage = (src) => new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img); img.onerror = () => resolve(null);
      img.src = src.startsWith('//') ? location.protocol + src : src;
    });

    const init = (root) => {
      const loc = root.dataset.locale || 'de';
      let L = {};
      try { L = JSON.parse(root.querySelector('[data-rzp-labels]')?.textContent || '{}'); } catch (e) { L = {}; }
      const rz = root.querySelector('.bsg-rz');
      const title = root.dataset.title || document.title;
      const url = root.dataset.url || location.href.split('?')[0];
      let scaleLabel = () => '';

      // Mengen: Personen-Rechner oder Faktor
      if (rz) {
        const cells = [...rz.querySelectorAll('.bsg-rz-menge')].filter((c) => c.dataset.q || c.dataset.q1);
        cells.forEach((c) => { c.dataset.orig = c.textContent; });
        const scale = (f) => cells.forEach((c) => {
          if (f === 1) { c.textContent = c.dataset.orig; return; }
          const pre = c.dataset.pre ? c.dataset.pre + ' ' : '', unit = c.dataset.unit ? ' ' + c.dataset.unit : '';
          const val = c.dataset.q ? fmt(c.dataset.q * f, loc) : fmt(c.dataset.q1 * f, loc) + '–' + fmt(c.dataset.q2 * f, loc);
          c.textContent = pre + val + unit;
        });
        const base = parseInt(rz.dataset.portionen || '', 10);
        const fuer = rz.querySelector('.bsg-rz-fuer');
        if (base && fuer) {
          let n = base;
          const box = document.createElement('div');
          box.className = 'bsg-rz-stepper';
          box.innerHTML = '<button type="button" data-d="-1" aria-label="−">−</button><output aria-live="polite"><b></b><span></span></output><button type="button" data-d="1" aria-label="+">+</button>';
          box.querySelector('output span').textContent = fuer.dataset.label || '';
          fuer.replaceWith(box);
          const render = () => {
            box.querySelector('b').textContent = n;
            box.querySelector('[data-d="-1"]').disabled = n <= 1;
            box.querySelector('[data-d="1"]').disabled = n >= 24;
            scale(n / base);
            root.querySelectorAll('[data-rzp-persons]').forEach((x) => { x.textContent = n; });
          };
          box.addEventListener('click', (e) => {
            const b = e.target.closest('button'); if (!b) return;
            n = Math.min(24, Math.max(1, n + Number(b.dataset.d))); render();
          });
          render();
          scaleLabel = () => (L.forPersons || '{n}').replace('{n}', n);
        } else if (cells.length) {
          let f = 1;
          const seg = document.createElement('div');
          seg.className = 'bsg-rz-faktor';
          seg.setAttribute('role', 'group');
          seg.setAttribute('aria-label', L.amount || '');
          seg.innerHTML = '<span></span>' + [['0.5', '½×'], ['1', '1×'], ['2', '2×'], ['3', '3×']]
            .map(([v, l]) => `<button type="button" data-f="${v}" aria-pressed="${v === '1'}">${l}</button>`).join('');
          seg.querySelector('span').textContent = L.amount || '';
          const h2 = rz.querySelector('.bsg-rz-zutaten h2');
          h2 ? h2.after(seg) : rz.querySelector('.bsg-rz-zutaten')?.prepend(seg);
          seg.addEventListener('click', (e) => {
            const b = e.target.closest('button'); if (!b) return;
            seg.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
            f = Number(b.dataset.f); scale(f);
          });
          scaleLabel = () => (f === 1 ? '' : `${L.amount || ''}: ${f === 0.5 ? '½' : f}×`);
        }
      }

      // Rezept als Daten (aktuelle Mengen aus der Seite)
      const collect = () => {
        const groups = rz ? [...rz.querySelectorAll('.bsg-rz-gruppe')].map((g) => ({
          title: clean(g.querySelector('h3')?.textContent),
          items: [...g.querySelectorAll('li')].map((li) => ({ amount: clean(li.querySelector('.bsg-rz-menge')?.textContent), item: clean(li.querySelector('.bsg-rz-zutat')?.textContent) }))
        })) : [];
        const steps = [];
        let section = '';
        if (rz) rz.querySelectorAll('.bsg-rz-schritte ol > li').forEach((li) => {
          if (li.classList.contains('bsg-rz-abschnitt')) { section = clean(li.textContent); return; }
          const h = clean(li.querySelector('h3')?.textContent);
          const text = [...li.querySelectorAll('p')].map((p) => clean(p.textContent)).filter(Boolean).join(' ');
          steps.push({ title: [section, h].filter(Boolean).join(' – '), text }); section = '';
        });
        const closing = clean(rz?.querySelector('.bsg-rz-schluss')?.textContent);
        const needT = clean(rz?.querySelector('.bsg-rz-zutaten h2')?.textContent);
        const howT = clean(rz?.querySelector('.bsg-rz-schritte h2')?.textContent);
        return { groups, steps, closing, needT, howT, scale: scaleLabel() };
      };
      const asText = (bold) => {
        const r = collect(); const b = (s) => (bold ? `*${s}*` : s);
        const out = [b(title)];
        if (r.scale) out.push(r.scale);
        out.push('', b(r.needT));
        r.groups.forEach((g) => { if (g.title) out.push(g.title); g.items.forEach((i) => out.push(`• ${[i.amount, i.item].filter(Boolean).join(' ')}`)); });
        out.push('', b(r.howT));
        r.steps.forEach((s, i) => out.push(`${i + 1}. ${s.title ? s.title + ': ' : ''}${s.text}`));
        if (r.closing) out.push(r.closing);
        out.push('', `${L.toRecipe || ''}: ${url}`);
        return out.join('\n');
      };

      const imageFile = async () => {
        try {
          const res = await fetch(root.dataset.img.startsWith('//') ? location.protocol + root.dataset.img : root.dataset.img);
          const blob = await res.blob();
          return new File([blob], `bschuessig-${slug(title)}.jpg`, { type: blob.type || 'image/jpeg' });
        } catch (e) { return null; }
      };
      // Mobil: Bild + Text über das Teilen-Menü (WhatsApp, Mail …); sonst Link mit Bildvorschau
      const shareWithImage = async () => {
        if (!navigator.canShare || !root.dataset.img || !/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) return false;
        const file = await imageFile();
        if (!file || !navigator.canShare({ files: [file] })) return false;
        try { await navigator.share({ files: [file], text: asText(true), title }); } catch (e) { /* abgebrochen */ }
        return true;
      };
      const sendWhatsApp = async () => {
        if (await shareWithImage()) return;
        window.open(`https://wa.me/?text=${encodeURIComponent(asText(true))}`, '_blank', 'noopener');
      };
      const sendMail = async () => {
        if (await shareWithImage()) return;
        location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(asText(false))}`;
      };
      const makePdf = async (btn) => {
        const old = btn.querySelector('span').textContent;
        btn.querySelector('span').textContent = L.pdfWait || '…'; btn.disabled = true;
        try {
          const [{ jsPDF }, img] = await Promise.all([loadJsPdf(), loadImage(root.dataset.img)]);
          const r = collect();
          const doc = new jsPDF({ unit: 'mm', format: 'a4' });
          const W = 210, M = 18, CW = W - 2 * M; let y = 16;
          const ink = [58, 43, 32], red = [196, 34, 44], grey = [110, 100, 90];
          const need = (h) => { if (y + h > 282) { doc.addPage(); y = 18; } };
          doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.setTextColor(...red);
          doc.text((L.shop || 'BSCHÜSSIG').toUpperCase(), M, y); y += 8;
          doc.setTextColor(...ink); doc.setFontSize(22);
          doc.splitTextToSize(title.toUpperCase(), CW).forEach((l) => { doc.text(l, M, y); y += 9; });
          if (r.scale) { doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(...grey); doc.text(r.scale, M, y); y += 6; }
          y += 2;
          if (img) {
            let iw = CW, h = CW * (img.naturalHeight / img.naturalWidth);
            if (h > 95) { iw = iw * 95 / h; h = 95; }
            const c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
            c.getContext('2d').drawImage(img, 0, 0);
            doc.addImage(c.toDataURL('image/jpeg', 0.85), 'JPEG', M, y, iw, h); y += h + 8;
          }
          const head = (s) => { need(14); doc.setFont('helvetica', 'bold'); doc.setFontSize(14); doc.setTextColor(...ink); doc.text(s.toUpperCase(), M, y); y += 3; doc.setDrawColor(231, 217, 189); doc.line(M, y, W - M, y); y += 6; };
          head(r.needT);
          r.groups.forEach((g) => {
            if (g.title) { need(7); doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.text(g.title, M, y); y += 6; }
            g.items.forEach((i) => {
              const lines = doc.splitTextToSize(i.item, CW - 34);
              need(lines.length * 5 + 1);
              doc.setFont('helvetica', 'bold'); doc.setFontSize(10.5); doc.text(i.amount || '', M, y);
              doc.setFont('helvetica', 'normal'); doc.text(lines, M + 34, y); y += lines.length * 5 + 1.5;
            });
          });
          y += 5; head(r.howT);
          r.steps.forEach((s, idx) => {
            const lines = doc.splitTextToSize(s.text, CW - 10);
            need(6 + lines.length * 5);
            doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(...red); doc.text(`${idx + 1}.`, M, y);
            doc.setTextColor(...ink);
            if (s.title) { doc.text(s.title, M + 10, y); y += 5.5; }
            doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5);
            lines.forEach((l) => { need(5); doc.text(l, M + 10, y); y += 5; }); y += 3;
          });
          if (r.closing) { need(6); doc.setFont('helvetica', 'bold'); doc.text(r.closing, M + 10, y); y += 7; }
          const pages = doc.getNumberOfPages();
          for (let p = 1; p <= pages; p++) {
            doc.setPage(p); doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(...grey);
            doc.text(url, M, 290); doc.text(`${p}/${pages}`, W - M, 290, { align: 'right' });
          }
          doc.save(`bschuessig-${slug(title)}.pdf`);
        } catch (e) {
          window.print();
        } finally {
          btn.querySelector('span').textContent = old; btn.disabled = false;
        }
      };

      // Sende-Leiste unter den Zutaten
      const zut = rz?.querySelector('.bsg-rz-zutaten');
      let bar = null;
      if (zut) {
        bar = document.createElement('div');
        bar.className = 'bsg-rz-senden';
        bar.innerHTML = `<p class="bsg-rz-senden__title"></p><div class="bsg-rz-senden__grid">
          <button type="button" data-act="whatsapp" class="is-wa">${ICONS.whatsapp}<span></span></button>
          <button type="button" data-act="mail">${ICONS.mail}<span></span></button>
          <button type="button" data-act="pdf">${ICONS.pdf}<span></span></button>
          <button type="button" data-act="print">${ICONS.print}<span></span></button></div>`;
        bar.querySelector('.bsg-rz-senden__title').textContent = L.sendTitle || '';
        ['whatsapp', 'mail', 'pdf', 'print'].forEach((k) => { bar.querySelector(`[data-act="${k}"] span`).textContent = L[k] || k; });
        zut.append(bar);
        bar.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-act]'); if (!b) return;
          ({ whatsapp: sendWhatsApp, mail: sendMail, pdf: () => makePdf(b), print: () => window.print() })[b.dataset.act]();
        });
      }
      root.querySelector('[data-rzp-print]')?.addEventListener('click', () => window.print());
      root.querySelector('[data-rzp-share]')?.addEventListener('click', () => {
        if (bar) { bar.scrollIntoView({ behavior: 'smooth', block: 'center' }); bar.classList.add('is-hl'); setTimeout(() => bar.classList.remove('is-hl'), 1600); }
        else sendWhatsApp();
      });
    };
    document.querySelectorAll('[data-rezept]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
